import { render, staticRenderFns } from "./SearchIdentity.vue?vue&type=template&id=ffaeed4e&scoped=true&"
import script from "./SearchIdentity.vue?vue&type=script&lang=js&"
export * from "./SearchIdentity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffaeed4e",
  null
  
)

export default component.exports